const reducer = (state, action) => {
  switch (action.type) {
    case "setShowingModal":
      return {
        ...state,
        showingModal: action.showingModal,
      };
    default:
      return state;
  }
};

const initialState = {
  showingModal: false,
};

export default {
  reducer,
  initialState,
};
